import { type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useBreakpoint } from "hooks/use-breakpoint";

import { Header, TitleWrapper, Title, Component } from "./styles";
import { BackButton } from "layouts/offer-bc/contentBC/back-button";

export interface ContentProps {
  title?: string;
  children: ReactNode;
}

export function Content({ title, children }: ContentProps) {
  const mdBreakpoint = useBreakpoint("md");
  const navigate = useNavigate();

  return (
    <>
      {mdBreakpoint && (
        <>
          <Header>
            <BackButton
              onClick={() => {
                navigate(-1);
              }}
            ></BackButton>
            <TitleWrapper>
              <Title>{title}</Title>
            </TitleWrapper>
          </Header>
        </>
      )}
      {<Component>{children}</Component>}
    </>
  );
}
